import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Jobs | Canny';
const Description =
  'Open roles at Canny. Join a small team that is fully remote, bootstrapped, and profitable.';
const Image = 'https://assets.canny.io/22423e37aa04e5a9aa907f449bd632d176a3ff72/team.jpg';

export default class JobsHomeHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://jobs.canny.io' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
